import { VFC } from 'react'
import styled, { css } from 'styled-components'

type WithMediaQueryFn = <T>(params: {
  WideComponent: VFC<T>
  NarrowComponent: VFC<T>
  wideMinWidth: number
}) => VFC<T>

export const withMediaQuery: WithMediaQueryFn =
  ({ WideComponent, NarrowComponent, wideMinWidth }) =>
  (props) => {
    return (
      <>
        <WideWrapper minWidth={wideMinWidth}>
          <WideComponent {...props} />
        </WideWrapper>
        <NarrowWrapper maxWidth={wideMinWidth - 1}>
          <NarrowComponent {...props} />
        </NarrowWrapper>
      </>
    )
  }

const NarrowWrapper = styled.div<{ maxWidth: number }>`
  ${({ maxWidth }) => css`
    @media screen and (min-width: ${maxWidth + 1}px) {
      display: none;
    }
  `}
`

const WideWrapper = styled.div<{ minWidth: number }>`
  ${({ minWidth }) => css`
    @media screen and (max-width: ${minWidth - 1}px) {
      display: none;
    }
  `}
`
